<template>
  <div :class="{'has-logo':showLogo}">
    <logo v-if="showLogo" :collapse="isCollapse" />
    <div class="menu-search-wrapper">
      <MenuSearch style="width: 83%;"/>
    </div>
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        :default-active="activeMenu"
        :collapse="isCollapse"
        :background-color="variables.menuBg"
        :text-color="variables.menuText"
        :unique-opened="$store.state.settings.uniqueOpened"
        :active-text-color="variables.menuActiveText"
        :collapse-transition="false"
        mode="vertical"
      >
        <!-- 未分组菜单 -->
        <sidebar-item
          v-for="(route, index) in ungroupedMenus"
          :key="route.path"
          :item="route"
          :base-path="route.path"
          :class="{'menuActive': route.path === activePath}"
          @click.native="toActive(route.path)"
        />
        <!-- 分组菜单 -->
        <template v-for="(group, groupKey) in groupedMenus">
          <div class="menu-group-title" v-if="!isCollapse">
            {{ getGroupTitle(groupKey) }}
          </div>
          <sidebar-item
            v-for="(route, index) in group"
            :key="route.path"
            :item="route"
            :base-path="route.path"
            :class="{'menuActive': route.path === activePath}"
            @click.native="toActive(route.path)"
          />
        </template>
		</el-menu>
    </el-scrollbar>
    <div v-if="entName && !isCollapse" class="sidebar-ent-name">{{ entName }}</div>
    <!-- <div class="user-card-wrapper">
      <user-card />
    </div> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Logo from './Logo'
import store from '@/store'
import SidebarItem from './SidebarItem'
import variables from '@/assets/styles/variables.scss'
import MenuSearch from '@/components/MenuSearch'
import UserCard from './UserCard'

export default {
  components: { SidebarItem, Logo, MenuSearch, UserCard },
  dicts: ['ENT_MENU_MAIN_NAVIGATION'],
	data() {
		return {
			activePath: '',
			// 菜单分组标题映射
			groupTitles: {
				'HRM': '人力资源管理',
				'ENTERPRISE_SERVICES': '企业服务'
			}
		}
	},
	mounted() {
		// console.log(this.permission_routers)
	},
  computed: {
    ...mapGetters([
      'permission_routers',
      'sidebar',
		'user'
    ]),
    activeMenu() {
      const route = this.$route
      const { meta, path } = route
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      return path
    },
    showLogo() {
      return this.$store.state.settings.sidebarLogo
    },
    variables() {
      return variables
    },
    isCollapse() {
      return !this.sidebar.opened
    },
    // 当前登录企业名称
    entName() {
      if (!this.user.enterpriseList) return ''
      const entObj = this.user.enterpriseList.find(item => item.entCode == this.user.entCode)
      return (entObj && entObj.entName) || ''
    },
    // 分组后的菜单
    groupedMenus() {
      const groups = {}
      // 过滤出有menuClass的菜单并分组
      this.permission_routers.forEach(route => {
        if (route.menuClass) {
          if (!groups[route.menuClass]) {
            groups[route.menuClass] = []
          }
          groups[route.menuClass].push(route)
        }
      })
      return groups
    },
    // 未分组的菜单
    ungroupedMenus() {
      return this.permission_routers.filter(route => !route.menuClass)
    }
  },
	methods:{
		toActive(path) {
			this.activePath = path
		},
		// 获取分组标题
		getGroupTitle(groupKey) {
			return this.dict.label.ENT_MENU_MAIN_NAVIGATION[groupKey] || groupKey
		}
	}
}
</script>

<style lang="scss" scoped>
/deep/.el-scrollbar__thumb {
  background-color: rgba(243, 231, 231, 0.6) !important;
}

.menu-group-title {
  padding: 12px 15px 8px 20px;
  font-size: 12px;
  color: #9CA3AF;
  // font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 1px;
  // background-color: rgba(0, 0, 0, 0.1);
}
.user-card-wrapper {
  margin-top: 20px;
  position: sticky;
  bottom: 0;
  z-index: 100;
  background: #fff;
}
// 底部企业名称
.sidebar-ent-name {
  position: sticky;
  bottom: 0;
  margin-top: auto;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 16px;
  border-top: 1px solid rgba(200, 210, 230, 0.35);
  background: rgba(249, 249, 253, 0.92);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  font-size: 11px;
  font-weight: 400;
  color: #b6c0cd;
  line-height: 1.4;
  text-align: center;
  cursor: default;
  user-select: none;
  word-break: break-all;
}
</style>
<style lang="scss">
  .scrollbar-wrapper{
    padding-bottom: 80px;
  }
  /deep/.el-scrollbar__thumb {
    background-color: rgba(243, 231, 231, 0.6) !important;
  }
  .has-margin {
    margin: 0 15px;
  }
  .el-menu {
    .menu-wrapper {
      border-radius: 10px;
      .el-submenu {
        border-radius: 10px;
        .el-submenu__title {
          background: #fff;
        }
      }
    }
  }
  .menu-search-wrapper {
    display: flex;
    justify-content: center;
    padding: 5px 0;
    background-color: inherit;
  }
</style>
